import { render, staticRenderFns } from "./UserTab4.vue?vue&type=template&id=43f71e76&scoped=true"
import script from "./UserTab4.vue?vue&type=script&lang=js"
export * from "./UserTab4.vue?vue&type=script&lang=js"
import style0 from "./UserTab4.vue?vue&type=style&index=0&id=43f71e76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f71e76",
  null
  
)

export default component.exports